__turbopack_context__.v({
  "navButton": "cxdlYa_navButton",
  "navIcon": "cxdlYa_navIcon",
});
